import React from 'react'
import { CellProps } from 'react-table'
import { formatDate } from '@helpers'

export default function DateCell({ value }: React.PropsWithChildren<CellProps<any, string>>) {
    return <>{formatDate(value)}</>
}